import produce from 'immer';

import {
  FETCH_NOTICE_BY_VIOLATION_TYPE_FAILURE,
  NOTICE_CREATE_FAILURE,
  NOTICE_EDIT_FAILURE,
  NOTICE_EDIT_SEQUENCE_FAILURE,
  NOTICE_EDIT_SEQUENCE_SUCCESS,
  NOTICE_EDIT_SUCCESS,
  NOTICE_FETCH_FAILURE,
  NOTICE_FETCH_SUCCESS,
  NOTICE_LIST_FETCH_FAILURE,
  NOTICE_LIST_FETCH_SUCCESS,
  SET_NOTICE_ID_SUCCESS,
  VERIFY_NOTICE_MERGE_CODES_FAILURE,
  VERIFY_NOTICE_MERGE_CODES_SUCCESS,
} from '@actions/notice';

const initialState: INoticeStore = {
  currentNotice: null,
  notices: null,
  currentNoticeId: null,
  noticeMergeCodes: null,
  error: null,
};

export default (state: INoticeStore = initialState, action: any) =>
  produce(state, (draftState: INoticeStore) => {
    switch (action.type) {
      case NOTICE_EDIT_SUCCESS:
      case NOTICE_FETCH_SUCCESS:
        draftState.currentNotice = action.response;
        draftState.error = null;

        return;

      case NOTICE_EDIT_FAILURE:
      case NOTICE_CREATE_FAILURE:
      case NOTICE_FETCH_FAILURE:
        draftState.currentNotice = null;
        draftState.error = action.error;

        return;

      case NOTICE_LIST_FETCH_FAILURE:
      case NOTICE_EDIT_SEQUENCE_FAILURE:
      case FETCH_NOTICE_BY_VIOLATION_TYPE_FAILURE:
        draftState.notices = null;
        draftState.error = action.error;

        return;

      case NOTICE_LIST_FETCH_SUCCESS:
      case NOTICE_EDIT_SEQUENCE_SUCCESS:
        draftState.notices = action.response;
        draftState.error = null;

        return;

      case VERIFY_NOTICE_MERGE_CODES_SUCCESS:
        draftState.noticeMergeCodes = action.response;
        draftState.error = null;

        return;

      case VERIFY_NOTICE_MERGE_CODES_FAILURE:
        draftState.error = null;

        return;

      case SET_NOTICE_ID_SUCCESS:
        draftState.currentNoticeId = action.currentNoticeId;

        return;
    }
  });
